module.exports = __webpack_public_path__ + "img/gray.75dd46a0.jpg";